import { apiClient } from '../apiClient';

export type FeedbackCategory =
  | 'getting_started'
  | 'live_sessions'
  | 'assignments'
  | 'coding'
  | 'technical'
  | 'other';

export const FEEDBACK_CATEGORY_LABELS: Record<FeedbackCategory, string> = {
  getting_started: 'Getting Started',
  live_sessions: 'Live Sessions',
  assignments: 'Assignments & Assessments',
  coding: 'Problems & Coding',
  technical: 'Technical Issues',
  other: 'Other',
};

export interface FeedbackItem {
  id: string;
  category: FeedbackCategory;
  message: string;
  student_id: string;
  student_name: string;
  student_email: string;
  created_at: string;
}

export interface FeedbackListResponse {
  items: FeedbackItem[];
  total: number;
}

export const feedbackApi = {
  submit: async (category: FeedbackCategory, message: string): Promise<{ id: string }> => {
    const { data } = await apiClient.post('/api/v1/feedback', { category, message });
    return data;
  },
  list: async (): Promise<FeedbackListResponse> => {
    const { data } = await apiClient.get('/api/v1/feedback');
    return (data as FeedbackListResponse) ?? { items: [], total: 0 };
  },
};
